import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const hideClearActionForDomainTrashbin = isFeature('hide-clear-action-for-domain-trashbin') || false;
